"use client"

import type React from "react"
import { FlagsProvider } from "flagged"
import { SessionProvider } from "next-auth/react"

import { FEATURE_FLAGS } from "@/config/flags"

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider refetchInterval={5 * 60} refetchOnWindowFocus>
      <FlagsProvider features={FEATURE_FLAGS}>{children}</FlagsProvider>
    </SessionProvider>
  )
}
